<div class="d-flex justify-content-center align-items-center p-5">
  <div class="bg-white shadow rounded p-4 w-100" style="max-width: 700px;">
    <div class="d-flex justify-content-between align-items-center mb-4">
      <h2 class="text-dark m-0">{{ translationService.getTranslation('User Permissions') }}</h2>
      <div class="btn btn-success" (click)="addModal()">{{ translationService.getTranslation('Add') }}</div>
    </div>
    
    <div class="mb-4">
      <label class="form-label">{{ translationService.getTranslation('Select User') }}</label>
      <select class="form-select" [(ngModel)]="selectedUser" (change)="onUserChange()">
          <option *ngFor="let user of users" [ngValue]="user">
            {{ user.Username }}
          </option>
        </select>
    </div>

    <div *ngIf="selectedUser">
      <div class="mb-4">
        <label class="form-label">{{ translationService.getTranslation('Branch') }}</label>
        <input type="text" class="form-control" [value]="selectedUser.branchName" disabled />
      </div>
      <table class="table table-bordered table-striped table-hover">
          <thead class="table-success">
          <tr>
            <th>{{ translationService.getTranslation('Permission') }}</th>
            <th class="text-center">{{ translationService.getTranslation('Enabled') }}</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let perm of permissionsList">
            <td>{{ perm }}</td>
            <td class="text-center">
              <input type="checkbox" class="form-check-input text-success" [(ngModel)]="selectedUserPermissions[perm]" />
          </td>
          </tr>
        </tbody>
      </table>

      <div class="mb-3">
        <label class="form-label">{{ translationService.getTranslation('Change Branch') }}</label>
        <select class="form-select" [(ngModel)]="branchSelected" (change)="getBranchSelected()">
          <option *ngFor="let branch of BranchesList" [ngValue]="branch">
            {{ branch.name }}
          </option>
        </select>
      </div>

      <button class="btn btn-success mt-3" (click)="savePermissions()">
        {{ translationService.getTranslation('Save') }}
      </button>

      
      <div class="alert alert-success mt-3" *ngIf="successMsg">
          {{ translationService.getTranslation('Permissions updated successfully') }}
      </div>
      
    </div>

  </div>

  <div *ngIf="openAddModal" class="modal fade show" tabindex="-1" role="dialog" aria-hidden="true" style="display: block;">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ translationService.getTranslation('Add New User')  }}</h5>
          <button type="button" class="btn-close mx-1" (click)="closeModal()" aria-label="Close"></button>
        </div>
        <div class="modal-body">

          <div class="mb-3">
            <label class="form-label">{{ translationService.getTranslation('User Name') }}</label>
            <input type="text" class="form-control" id="folderName" [(ngModel)]="newUserName" name="folderName" required autocomplete="off" />
          </div>
          <div class="mb-3">
            <label class="form-label">{{ translationService.getTranslation('Email at AlArkkan') }}</label>
            <input type="text" class="form-control" id="folderName" [(ngModel)]="newUserEmail" name="folderName" required autocomplete="off" />
          </div>
          <div class="mb-3">
            <label class="form-label">{{ translationService.getTranslation('Branch') }}</label>
            <select class="form-select" [(ngModel)]="branchSelected" (change)="getBranchSelected()">
              <option *ngFor="let branch of BranchesList" [ngValue]="branch">
                {{ branch.name }}
              </option>
            </select>
          </div>

          <div class="d-flex justify-content-between mt-4">
            <button type="submit" class="btn btn-success" (click)="addNewUser()" [disabled]="!newUserName || !newUserEmail || !branchSelected">
              <i class="bi bi-person-add"></i> {{ translationService.getTranslation('Add User') }}
            </button>            
            <button type="button" class="btn btn-secondary" (click)="closeModal()">
              <i class="bi bi-x-circle"></i> {{ translationService.getTranslation('Cancel') }}
            </button>
          </div>
        </div>        
      </div>
    </div>
  </div>
</div>
  